import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  StudentFilter as StudentFilterModel,
  StudentReportEventTrackingRequest,
  StudentReportEventTrackingResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { EventTrackingDisplay } from "./EventTrackingDisplay";
import { StudentServiceFilter } from "pages/students/student-services/StudentServiceFilter";
import { StudentFilter } from "pages/students/students/StudentFilter";

export const EventTrackingRequest = (props: {
  initialized: boolean;
  request: StudentReportEventTrackingRequest;
  setRequest: (value: StudentReportEventTrackingRequest) => void;
  globalCommonFilter: StudentFilterModel;
  setGlobalCommonFilter: (value: StudentFilterModel) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StudentReportEventTrackingResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.studentReports.getEventTrackingRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.studentReports.getEventTrackingResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <Card header="Common Filter">
        <StudentFilter
          filter={props.globalCommonFilter || ({} as StudentFilterModel)}
          setFilter={props.setGlobalCommonFilter}
        />
      </Card>

      <Card header="Service Filter">
        <StudentServiceFilter
          filter={props.request.studentServiceFilter || {}}
          setFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentServiceFilter = filter;
              })
            )
          }
          showInputs={["date", "serviceType"]}
        />
      </Card>

      <EventTrackingDisplay
        display={props.request.display || {}}
        setDisplay={(display) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.display = display;
            })
          )
        }
        resource={resource.display || {}}
        validationErrors={props.validationErrors[pn<StudentReportEventTrackingRequest>("display")] || {}}
      />
    </Stack>
  );
};
